import { render, staticRenderFns } from "./TestPackageView.vue?vue&type=template&id=6b71280c"
import script from "./TestPackageView.vue?vue&type=script&lang=js"
export * from "./TestPackageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports